import React, { createContext, useContext, useState, useEffect } from "react";
import { BASE_URL } from "../config/apiConfig";
// CHANGED: Removed unused `import { toast } from "react-toastify"` — no toast calls remain in this file
// since fetchAttendanceReports is a read-only fetch operation.

const AttendanceReportContext = createContext();
export const useAttendanceReport = () => useContext(AttendanceReportContext);

// CHANGED: Added a safe JSON parsing helper to prevent "Unexpected token '<'" crashes.
// This guards against cases where the backend returns an HTML error page (404/500/proxy errors)
// or an empty body instead of valid JSON, which previously caused res.json() to throw.
const safeParseJSON = async (res) => {
  try {
    const text = await res.text();
    if (!text) {
      return { status: false, message: "Empty response from server" };
    }
    try {
      return JSON.parse(text);
    } catch (parseErr) {
      return { status: false, message: "Invalid response format from server" };
    }
  } catch (readErr) {
    return { status: false, message: "Failed to read server response" };
  }
};

export const AttendanceReportProvider = ({ children }) => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const token = localStorage.getItem("token");

  // Fetch all attendance reports — fetch operation, no toasts
  // CHANGED: Removed all toast.error calls (including the 401/session-expired case) —
  // this is a GET/fetch operation (including on initial page load), not a user action.
  const fetchAttendanceReports = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      setError("No authentication token found");
      setReports([]);
      return;
    }
    
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/attendance-report`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (res.status === 401) {
        setError("Session expired. Please log in again.");
        // CHANGED: removed toast.error("Session expired. Please log in again.")
        return;
      }

      const data = await safeParseJSON(res); // CHANGED: safe parsing instead of res.json()
      if (data.status) {
        setReports(data.data);
      } else {
        setError(data.message || "Failed to fetch attendance reports");
        // CHANGED: removed toast.error(data.message || "Failed to fetch attendance reports")
      }
    } catch (err) {
      console.error(err);
      setError("Error fetching attendance reports");
      // CHANGED: removed toast.error("Error fetching attendance reports")
    } finally {
      setLoading(false);
    }
  };

  // Optionally, fetch on mount
  useEffect(() => {
    fetchAttendanceReports();
  }, []);

  return (
    <AttendanceReportContext.Provider
      value={{ reports, loading, error, fetchAttendanceReports }}
    >
      {children}
    </AttendanceReportContext.Provider>
  );
};